import { Button, Input, Notification, Select, toast } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import { ModalContext } from "contexts/ModalContext";
import { TrendingNewsContext } from "contexts/TrendingNewsContext";
import React, { useContext, useEffect, useState } from "react";
import { HiCheckCircle, HiOutlineMagnifyingGlass } from "react-icons/hi2";

import { useNavigate } from "react-router-dom";
import { getReadableByURL } from "utils/getReadableByURL";

import { useTrendingNews } from "utils/hooks/useTrendingNews";
import TrendingNewsItem from "views/home/TrendingNewsItem";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import SocialNetworkSidePanel from "views/calendar/SocialNetworkSidePanel";
import InputModern from "components/ui/Input/InputModern";
import { socialNetworkPrompts, socialNetworkPromptsSuffix } from "components/layout/MagicEditor/functions/AdaptToSocialNetwork";
import { CalendarActiveSocialNetworkContext } from "contexts/CalendarActiveSocialNetworkContext";
import { Trans, useTranslation } from "react-i18next";
import { AIContext } from "contexts/AIContext";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";
import ConfigPanel from "../ConfigPanel";


const RawTemplate = ({
    generatePostsFromContexts,
    config,
    setConfig
}) => {

    const maxSelection = usePostGenerationQuantity();

    const maxChars = 30000;

    const { company } = useContext(CompanyContext);
    const [ quantity, setQuantity ] = useState(1);
    const [ rawContent, setRawContent ] = useState("");
    const { t } = useTranslation();

    const quantityOptions = Array.from(Array(maxSelection).keys()).map((quantity) => {
        return { value: quantity + 1, label: `Generate ${quantity + 1} option${quantity + 1 > 1 ? `s` : ``}` }
    })

    const handleOnSubmit = async () => {
        generatePostsFromContexts([{ source: { kind: 'text', content: rawContent.substring(0, Math.min(maxChars, rawContent?.length)) } }], undefined, quantity || 1);
    }
    
    return (
        <div className="w-full h-full flex items-start p-4 gap-4">
            <ConfigPanel 
                selected={!!rawContent ? Array.from(Array(quantity).keys()) : []}
                onSubmit={handleOnSubmit}
                config={config}
                setConfig={setConfig}
            />
            <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full h-full overflow-y-auto bg-secondary-500 dark:bg-gray-800 rounded-2xl">
                <div className="overflow-y-auto p-1 shrink-0 flex-1 p-4 flex flex-col">
                    <div className='p-0 relative pb-4'> 
                        <Select
                            placeholder={t(`rawTemplate.placeholderQuantity`)}
                            options={quantityOptions}
                            value={quantityOptions?.filter(e => e.value == quantity)?.[0]}
                            onChange={(option) => setQuantity(option?.value)}
                            className="bg-gray-50 dark:bg-gray-600 rounded-2xl border-0"
                            fieldsetClassName="rounded-2xl !border-0"
                        />
                    </div>
                    <div className="flex-1 min-h-[300px]">
                        <InputModern 
                            textArea
                            value={rawContent}
                            onChange={(e) => setRawContent(e.target.value)}
                            className={`!p-5 lg:!p-6 !px-5 h-full transition-all bg-gray-50 dark:bg-gray-600 rounded-2xl`}
                            placeholder={t(`rawTemplate.placeholderRawContent`)}
                            fieldsetClassName="h-full bg-gray-50 dark:bg-gray-600"
                            maxLength={maxChars}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RawTemplate;